import React from 'react';
import useAppInit from './hooks/use-app-init';
import usePageTracking from 'state/hooks/use-page-tracking';
import LoadingScreen from 'components/@common/LoadingScreen/LoadingScreen';
import Config from 'config';

const { gaTrackingId } = Config;

const AppInit: React.FC<any> = ({ children }) => {
  const { loading } = useAppInit();
  usePageTracking(gaTrackingId);

  if (loading) return <LoadingScreen loading={true} />;

  return children;
};

export default AppInit;
